import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/img/Logo.jpeg";
import "./styles.scss";
import { AppName } from "../../lib/data";

const Home: React.FC = () => {
     const navigate = useNavigate();

     return (
          <div className="home-container">
               {/* Navbar */}
               <nav className="navbar">
                    <div className="navbar-content">
                         <div className="logo-section">
                              <img src={Logo} alt={AppName} className="logo" />
                         </div>
                         <div className="nav-actions">
                              <button
                                   className="nav-link"
                                   onClick={() => navigate("/login")}
                              >
                                   Sign In
                              </button>
                              <button
                                   className="get-started-btn"
                                   onClick={() => navigate("/register")}
                              >
                                   Get Started
                              </button>
                         </div>
                    </div>
               </nav>

               {/* Hero Section */}
               <section className="hero-section">
                    <div className="hero-content">
                         <div className="hero-left">
                              <h1 className="hero-title">
                                   Welcome to
                                   <span className="highlight">
                                        {" "}
                                        Premium Lending
                                   </span>
                              </h1>
                              <p className="hero-description">
                                   {AppName} provides fast, flexible loan
                                   solutions tailored to your needs. Experience
                                   seamless lending with competitive rates and
                                   exceptional service.
                              </p>
                              <div className="hero-cta">
                                   <button
                                        className="cta-primary"
                                        onClick={() => navigate("/register")}
                                   >
                                        Get Started
                                   </button>
                                   <button
                                        className="cta-secondary"
                                        onClick={() => navigate("/login")}
                                   >
                                        Login
                                   </button>
                              </div>
                         </div>
                    </div>
               </section>
          </div>
     );
};

export default Home;
